import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateProviderProfile, updateProviderProfile } from "./update-provider-profile-";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateProviderProfileReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateProviderProfile.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateProviderProfile.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateProviderProfile.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateProviderProfile, () => {
    return initialState;
  });
});
